import React from 'react';
import { Button } from '../ButtonElement';

const PdfButton = ({ pdfLink, pdfButtonLabel, primary, dark, dark2 }) => {

    return (
        <Button
            as="a"
            href={pdfLink}
            target="_blank"
            rel="noopener noreferrer"
            primary={primary ? 1 : 0} 
            dark={dark ? 1 : 0} 
            dark2={dark2 ? 0 : 1} 
            appear={true}
        >
            {pdfButtonLabel}
        </Button>
    );
};

export default PdfButton;
